var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"bold text-none",attrs:{"rounded":"","elevation":"0"},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$props,false),[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }